(function () {
  if (location.pathname.includes('/challenge')) return;
  if (!location.search) return;

  var functionalKeep = [
    'q',
    'page',
    'sort_by',
    'view',
    'variant',
    'options',
    'color',
    'size'
  ];

  var functionalPrefixes = [
    'filter.',
    'options[',
    'options%5B',
    'variant[',
    'variant%5B'
  ];

  function isFunctionalParam(name) {
    if (functionalKeep.indexOf(name) !== -1) return true;

    for (var i = 0; i < functionalPrefixes.length; i++) {
      if (name.indexOf(functionalPrefixes[i]) === 0) return true;
    }

    return false;
  }

  function saveTrackingParams(params) {
    try {
      var expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();

      params.forEach(function (value, key) {
        if (isFunctionalParam(key)) return;

        document.cookie =
          'attr_' + encodeURIComponent(key) + '=' + encodeURIComponent(value) +
          '; expires=' + expires +
          '; path=/' +
          '; SameSite=Lax';

        try {
          localStorage.setItem('attr_' + key, value);
        } catch (e) {}
      });
    } catch (e) {}
  }

  function cleanUrl() {
    try {
      var url = new URL(location.href);
      var params = url.searchParams;
      var changed = false;

      Array.from(params.keys()).forEach(function (key) {
        if (!isFunctionalParam(key)) {
          params.delete(key);
          changed = true;
        }
      });

      if (!changed) return;

      var clean =
        url.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        url.hash;

      history.replaceState(null, '', clean);
    } catch (e) {}
  }

  try {
    var currentUrl = new URL(location.href);

    saveTrackingParams(currentUrl.searchParams);

    window.setTimeout(cleanUrl, 1500);
  } catch (e) {}
})();